import { ICategories, IEntities, IKeyTopics } from '../services/common/nlp/klangoo-config'
import { Utils } from './common'

/**
 * Klangoo helper functions.
 */
export const KlangooUtils = {
    /**
     * Filters and converts Klangoo entity (only token)
     * array of object into string
     *
     * @param {array}
     * @param {number}
     * @param {number}
     * @return {array}
     */

     stringifyFilteredEntities(entities: IEntities[], maxListSize?: number, threshold?: number): string[] {
        if (entities) {
            const maxSize = maxListSize> 0? maxListSize:entities.length
            if ( threshold) {
                return entities
                    .filter((item) => item.score > threshold)
                    .slice(0, maxSize)
                    .map((item) => Utils.decodeHtmlEntity(`${item.type},${item.subtype},${item.token}`))
            } else {
                return entities
                        .slice(0, maxSize)
                        .map((item) => Utils.decodeHtmlEntity(
                            `${item.type},${item.subtype},${item.token},${item.score}`))
            }
        }
        return []
    },
    /**
     * Converts Klangoo KeyTopics array of object into string
     *
     * @param {array}
     * @param {number}
     *
     * @return {string}
     */

    stringifyFilteredKeytopics(keyTopics: IKeyTopics[], maxListSize?: number): string {
        if (keyTopics) {
            const maxSize = maxListSize> 0? maxListSize:keyTopics.length
            return keyTopics
                .slice(0, maxSize)
                .map((item) => Utils.decodeHtmlEntity(`${item.text},${item.score}`))
                .join('|')
        }
        return ''
    },

    /**
     * Converts Klangoo categories array of object into string
     *
     * @param {array}
     *
     * @return {array}
     */

     stringifyFilteredCategories(categories: ICategories[]): string[] {
        if (categories) {
            return categories
                .map((category) => Utils.decodeHtmlEntity(category.name))
        }
        return []
    }
}
